export interface BreadcrumbParent {
  label: string;
  to: string;
}

export interface BreadcrumbHandle {
  crumb?: unknown;
  parent?: BreadcrumbParent;
}

export interface BreadcrumbMatch {
  pathname: string;
  handle?: unknown;
}

export interface BreadcrumbItem {
  label: string;
  to?: string;
  current: boolean;
}

function isBreadcrumbHandle(handle: unknown): handle is BreadcrumbHandle {
  return typeof handle === "object" && handle !== null;
}

function isBreadcrumbParent(parent: unknown): parent is BreadcrumbParent {
  return (
    typeof parent === "object" &&
    parent !== null &&
    "label" in parent &&
    "to" in parent &&
    typeof parent.label === "string" &&
    typeof parent.to === "string"
  );
}

export function getBreadcrumbItems(matches: readonly BreadcrumbMatch[]): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [];

  for (const match of matches) {
    if (!isBreadcrumbHandle(match.handle)) continue;
    if (typeof match.handle.crumb !== "string") continue;

    const parent = match.handle.parent;

    if (isBreadcrumbParent(parent)) {
      const alreadyIncluded = items.some((item) => item.to === parent.to);
      if (!alreadyIncluded) {
        items.push({
          label: parent.label,
          to: parent.to,
          current: false,
        });
      }
    }

    items.push({
      label: match.handle.crumb,
      to: match.pathname,
      current: false,
    });
  }

  if (items.length === 0) return [];

  return items.map((item, index) =>
    index === items.length - 1 ? { label: item.label, current: true } : { ...item, current: false },
  );
}
